import {
  createTaskWithSubTasks as _createTaskWithSubTasks,
  TaskRelationshipLink,
} from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  setDoc,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { NewSubTask, NewTask, Task } from 'shared/types/task';

import { getAuthentication, getDatabase } from './helpers';

export type { TaskRelationshipLink } from '@griply/services';

export const createTaskWithSubTasks = async (
  task: NewTask,
  subTasks: NewSubTask[],
  relationshipLinks: TaskRelationshipLink[] = [],
) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return (await _createTaskWithSubTasks({
    task,
    subTasks,
    relationshipLinks,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db,
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (_db) => writeBatch(_db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.CreateTaskWithSubTasks,
        error,
        uid: user.uid,
      }),
  })) as unknown as Task;
};
